import * as actionTypes from './../actions/petInfoAction';

const initialState = {
  data: [],
  pending: true,
  error: null,
  ready: false,
  mealsPerDay: 2,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.DEFAULT:
      return {
        ...state,
        mealsPerDay: 2,
        petName: "",
        clinicRecordNumber: "",
        ready: true,
      };
    case actionTypes.FETCH_DATA_PENDING:
      return {
        ...state,
        pending: true
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        ready: true,
        data: action.data
      };

    case actionTypes.SET_PET_NAME:
    case actionTypes.SET_CLINIC_RECORD_NUMBER:
    case actionTypes.SET_MEALS_PER_DAY:
      return Object.assign({}, state, action);

    case actionTypes.FETCH_DATA_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;
